import script from "./PhotoGalleryDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./PhotoGalleryDetails.vue?vue&type=script&setup=true&lang=js"

import "./PhotoGalleryDetails.vue?vue&type=style&index=0&id=711f0d25&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-711f0d25"]])

export default __exports__